<template>
  <div id="classdetail">
    <!--引用公共头部-->
    <top-head :pageName="pageName" @listenLogin="showLogin"></top-head>
    <h2 class="title">
      <a @click="back" class="prev"></a>
    </h2>
    <div class="video">
      <div class="top" v-if="bannerShow" @click="hideBanner">
        <img src="@/assets/icon/classdetail_icon_listen.png" alt="" class="listen" v-if="this.currentVideoVid">
        <img :src="topBanner" class="topbanner">
      </div>
      <div id="videoPolyv"></div>
    </div>
    <div class="main">
      <div class="tag">新品</div>
      <h2 :alt="classId">
        <b>{{className}}</b>
        <span>¥{{classPrice}}</span>
      </h2>
      <div class="subtitle">
        <span>{{classNameMain}}</span>
        <span>已有{{sellNum}}人购买</span>
      </div>
      <!--赠送-->
      <div class="gift" v-show="giftNum">
        <a href="">
          <span class="tag"></span>
          <div class="t">
            {{giftName}}
            <div class="s">{{giftNum}}个赠品</div>
          </div>
        </a>
      </div>
      <ul class="swiper-pagination" id="nav-pagination"></ul>
      <!--课程详情-->
      <div class="detail">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <!--课程介绍-->
            <div class="swiper-slide intro">
              <!--<div v-html="detailHtml"></div>-->
              <!--<img src="../../assets/img/classdetail_class_detail_intro.png" alt="" width="100%">-->
              <img :src="item.img" v-for="(item, index) in detailImg" :key="index" width="100%">
              <p>{{detailText}}</p>
            </div>
            <!--课程列表-->
            <div class="swiper-slide course">
              <dl class="cc" v-for="(item, index) in courseList" :key="index">
                <dt class="active" @click="showAndHide">
                  <h5>{{index + 1}} | {{item.name}}</h5>
                  <span class="arrow"></span>
                </dt>
                <video-list :class_id="classId" :course_id="item.course_id"></video-list>
              </dl>
            </div>
            <!--授课老师-->
            <div class="swiper-slide teacher">
              <dl v-for="(item, index) in teacherInfo" :key="index">
                <dt><img :src="item.portrait" alt=""></dt>
                <dd>
                  <h4>{{item.nickname}}</h4>
                  <p>
                    {{item.introduce}}
                  </p>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="fix-bar">
      <div class="price">{{classPrice}}</div>
      <div class="pay">
        <a @click="easyChat">咨询客服</a>
        <a @click="showChoose()">立即购买</a>
      </div>
    </div>
    <div class="clear"></div>
    <class-single :classId="this.classId" :shopType="this.shopType" :className = "className" :giftName = "giftName" :classPrice="classPrice" :smallBannerPic="smallBannerPic" v-if="popupChoose" v-on:listenShow="hideChoose()"></class-single>
    <i-login @listenShow="showLogin" v-show="loginShow"></i-login>
  </div>
</template>

<script>
import Swiper from 'swiper'
/* eslint-disable no-new */
import VideoList from './ClassDetailVideoList'
import ClassSingle from '../share/popup/class/ClassSingle'
import iLogin from '../share/popup/login/iLogin'
import topHead from '../share/header/topHead'
export default {
  name: 'ClassDetailTeacher',
  data () {
    return {
      classId: this.$route.query.class_id ? this.$route.query.class_id : 299, // 282
      shopType: 0,
      courseList: {},
      className: '',
      classNameMain: '', // 班级副标题
      classPrice: '', // 现价
      originalPrice: '', // 原价
      detailHtml: '', // 班级详情 包含 html
      detailImg: '', // 班级详情 若为图片 则这里为存储路径 否则为空
      detailText: '', // 班级详情 若为文本 则这里为存文本内容 否则为空
      sellNum: '', // 售出量
      currentVideoVid: '5111745181237048c371631853d0fc74_5', // 预览视频
      player: null,
      giftName: '作文范文集',
      giftNum: 0,
      teacherInfo: '',
      mySwiper: null,
      popupChoose: false,
      loginShow: 0,
      pageName: 'ClassDetailTeacher',
      topBanner: '', // 封面图
      smallBannerPic: '', // 支付前小图
      bannerShow: 1 // 显示封面图
    }
  },
  components: {
    VideoList,
    ClassSingle,
    iLogin,
    topHead
  },
  methods: {
    // 未购买班级详情
    getCourseBuy () {
      let data = {
        class_id: this.$route.query.class_id ? this.$route.query.class_id : this.classId
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_live_course_details',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          if (res.data.errcode === 200) {
            console.log('课程详情')
            console.log(res)
            this.className = res.data.data.name
            this.classNameMain = res.data.data.name_main
            this.classPrice = res.data.data.present_price
            this.originalPrice = res.data.data.original_price
            this.detailHtml = res.data.data.details
            if (res.data.data.details_img.length > 0) {
              this.detailImg = JSON.parse(res.data.data.details_img)
            }
            this.detailText = res.data.data.details_text
            this.sellNum = res.data.data.sum_price
            this.currentVideoVid = res.data.data.details_video
            this.giftName = res.data.data.gift_name
            this.giftNum = res.data.data.gift_count
            this.topBanner = res.data.data.app_img_2
            this.smallBannerPic = res.data.data.app_img_1
            this.$nextTick(() => {

            })
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获得老师信息
    getTeacher () {
      let data = {
        class_id: this.$route.query.class_id ? this.$route.query.class_id : this.classId
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_live_first_teacher',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          if (res.data.errcode === 200) {
            this.teacherInfo = res.data.data
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    getVideo () {
      if (this.currentVideoVid) {
        this.player = window.polyvObject('#videoPolyv').videoPlayer({
          width: '7.5rem',
          height: '4rem',
          vid: this.currentVideoVid
          // forceH5: true
        })
      }
    },
    // 获得章节列表
    getCourseList () {
      let data = {
        class_id: this.$route.query.class_id ? this.$route.query.class_id : this.classId
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_live_first_list',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res) // 上线前删除
          if (res.data.errcode === 200) {
            this.courseList = res.data.data
          } else {
            console.log(res.data.message)
            // this.$router.push({name: 'PwdLogin'})
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    hideChoose () {
      this.popupChoose = false
    },
    showChoose () {
      if (this.$store.state.uid === '' || this.$store.state.uid === undefined) {
        this.loginShow = true
        return false
      }
      if (this.validataToken()) {
        this.popupChoose = true
      }
    },
    back () {
      if (window.history.length <= 1) {
        this.$router.push({name: 'Index'})
      } else {
        this.$router.go(-1)
      }
    },
    showAndHide (event) {
      let _el = event.currentTarget
      if (_el.getAttribute('class') === 'active') {
        _el.setAttribute('class', '')
      } else {
        _el.setAttribute('class', 'active')
      }
    },
    // 验证是否需要登录弹窗
    validataToken () {
      let data = {
      }
      return this.$axios({
        method: 'GET',
        url: '/api/app/v1/overdue_user_token',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            return true
          } else if (res.data.errcode === 400) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.loginShow = true
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.loginShow = true
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    easyChat () {
      // openJesongChatByGroup(12523, 20519)
      this.$easyliao(12523, 20523)
      return false
    },
    showLogin (isShow) {
      this.loginShow = isShow
    },
    hideBanner () {
      if (this.currentVideoVid) {
        this.bannerShow = 0
        this.player.j2s_resumeVideo()
      }
    }
  },
  mounted () {
    this.getCourseBuy()
    this.getTeacher()
    this.getCourseList()
    this.mySwiper = new Swiper('#classdetail .detail .swiper-container', {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          let text = ''
          switch (index) {
            case 0: text = '课程介绍'; break
            case 1: text = '课程列表'; break
            case 2: text = '授课老师'; break
          }
          return '<li class="' + className + '">' + text + '</li>'
        }
      },
      observer: true, // 修改swiper自己或子元素时，自动初始化swiper
      observeParents: true // 修改swiper的父元素时，自动初始化swiper
    })
  },
  updated () {

  },
  watch: {
    currentVideoVid: 'getVideo'
  }
}
</script>

<style scoped lang="stylus">
#classdetail
  >>> #tophead
    padding: 0 .4rem
  .title
    position: absolute
    height: 1.08rem
    line-height: .8rem
    background-color: transparent
    padding: .14rem .16rem
    font-size: .32rem
    color: #050505
    font-weight: 600
    text-align: center
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    a.prev
      position: absolute
      top: .14rem
      left: .16rem
      z-index: 1001
      display: block
      width: .8rem
      height: .8rem
      background-color: transparent
      -webkit-border-radius: 50%
      -moz-border-radius: 50%
      border-radius: 50%
      &::before
        content: ""
        position: absolute
        top: .3rem
        left: .32rem
        display: block
        width: .20rem
        height: .20rem
        border-left: .03rem solid #fff
        border-bottom: .03rem solid #fff
        -webkit-transform: rotate(45deg)
        -moz-transform: rotate(45deg)
        -ms-transform: rotate(45deg)
        -o-transform: rotate(45deg)
        transform: rotate(45deg)
  .video
    position: relative
    width: 7.5rem
    height: 4rem
    background: url(../../assets/img/classdetail_video_bg.png) no-repeat center
    -webkit-background-size: 100%
    background-size: 100%
    .top
      position: absolute
      top: 0
      left: 0
      z-index: 1000
      width: 7.5rem
      height: 4rem
      .listen
        position: absolute
        top: 50%
        left: 50%
        width: 1.52rem
        height: .56rem
        -webkit-transform: translate(-50%, -50%)
        -moz-transform: translate(-50%, -50%)
        -ms-transform: translate(-50%, -50%)
        -o-transform: translate(-50%, -50%)
        transform: translate(-50%, -50%)
      .topbanner
        width: 100%
        height: 100%
  .main
    position: relative
    top: -.2rem
    z-index: 1000
    background-color: #fff
    -webkit-border-radius: .2rem .2rem 0 0
    -moz-border-radius: .2rem .2rem 0 0
    border-radius: .2rem .2rem 0 0
    overflow: hidden
    & > .tag
      display: block
      width: .72rem
      height: .36rem
      line-height: .36rem
      background-color: #FF7052
      margin: .3rem 0 0 .4rem
      font-size: .24rem
      color: #fff
      text-align: center
      -webkit-border-radius: .04rem
      -moz-border-radius: .04rem
      border-radius: .04rem
    & > h2
      display: flex
      justify-content: space-between
      align-items: center
      margin: .16rem .4rem .04rem
      text-align: left
      b
        font-size: .34rem
        color: #050505
        font-weight: 500
    & > .subtitle
      display: flex
      justify-content: space-between
      align-items: center
      margin: 0 .4rem .4rem
      text-align: left
      span
        font-size: .22rem
        color: #9DA4B3
        &:last-child
          display: none
          width: 2rem
          text-align: right
    .gift
      position: relative
      display: flex
      justify-content: left
      align-items: center
      height: 1.2rem
      padding: .22rem .4rem
      background-color: #FAFAFA
      margin: .0 .4rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      -webkit-border-radius: .2rem
      -moz-border-radius: .2rem
      border-radius: .2rem
      &::before
        content: "赠"
        display: block
        width: .4rem
        height: .4rem
        line-height: .4rem
        border: .01rem solid #FF7052
        -webkit-border-radius: .08rem
        -moz-border-radius: .08rem
        border-radius: .08rem
        font-size: .28rem
        color: #FF7052
        text-align: center
      &::after
        content: ""
        position: absolute
        top: .5rem
        right: .4rem
        display: block
        width: .15rem
        height: .15rem
        border-top: .02rem solid #CFD1D4
        border-right: .02rem solid #CFD1D4
        transform: rotate(45deg)
      .t
        margin-left: .18rem
        font-size: .28rem
        color: #050505
        .s
          font-size: .22rem
          color: #9DA4B3
    #nav-pagination
      position: static
      display: flex
      justify-content: space-around
      margin: .4rem auto
      >>> .swiper-pagination-bullet
        width: 1.5rem
        height: .5rem
        background-color: transparent
        opacity: 1
        font-size: .3rem
        color: #050505
        -webkit-border-radius: 0
        -moz-border-radius: 0
        border-radius: 0
        &.swiper-pagination-bullet-active
          position: relative
          border: none
          color: #1E81F2
          &::after
            content: ""
            position: absolute
            bottom: -.08rem
            left: 50%
            display: block
            width: .8rem
            height: .04rem
            background-color: #1E81F2
            margin-left: -.4rem
    div.detail
      .intro
        overflow: hidden
        img
          width: 100%
          vertical-align: middle
      .teacher
        dl
          display: flex
          justify-content: space-between
          padding: .4rem
          dt
            width: .88rem
            height: .88rem
            img
              width: 100%
          dd
            width: 5.62rem
            min-height: 2.61rem
            border-bottom: .02rem solid #CFD1D4
            h4
              margin: .22rem 0
              font-size: .32rem
              color: #050505
              font-weight: bold
            p
              font-size: .26rem
              color: #999
              text-align: justify
              text-justify: inter-word
      .course
        padding: 0 .4rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        >>> dl
          dt
            display: flex
            justify-content: space-between
            align-items: center
            width: 6.7rem
            height: .8rem
            padding: 0 .3rem
            margin-top: .2rem
            -webkit-box-sizing: border-box
            -moz-box-sizing: border-box
            box-sizing: border-box
            -webkit-box-shadow: 0 0.04rem 0.08rem 0 rgba(227,231,230,0.74);
            -moz-box-shadow: 0 0.04rem 0.08rem 0 rgba(227,231,230,0.74);
            box-shadow: 0 0.04rem 0.08rem 0 rgba(227,231,230,0.74);
            -webkit-border-radius: .05rem
            -moz-border-radius: .05rem
            border-radius: .05rem
            h5
              font-size: .3rem
              color: #050505
            span.arrow
              &::before
                content: ""
                position: relative
                top: -.04rem
                right: .1rem
                display: inline-block
                width: .1rem
                height: .1rem
                border-left: .03rem solid #666
                border-bottom: .03rem solid #666
                -webkit-transform: rotate(-45deg)
                -moz-transform: rotate(-45deg)
                -ms-transform: rotate(-45deg)
                -o-transform: rotate(-45deg)
                transform: rotate(-45deg)
            &.active
              -webkit-box-shadow: none
              -moz-box-shadow: none
              box-shadow: none
              span.arrow
                &::before
                  top: 0
                  -webkit-transform: rotate(135deg)
                  -moz-transform: rotate(135deg)
                  -ms-transform: rotate(135deg)
                  -o-transform: rotate(135deg)
                  transform: rotate(135deg)
            &.active + dd
              display: block
          dd
            display: none
            width: 6.7rem
            background-color: #FAFAFA
            padding: 0 .2rem
            margin-top: .2rem
            -webkit-box-sizing: border-box
            -moz-box-sizing: border-box
            box-sizing: border-box
            -webkit-border-radius: .2rem
            -moz-border-radius: .2rem
            border-radius: .2rem
            a
              display: block
              width: 100%
              height: 1.1rem
              border-bottom: .02rem solid #E1E1E1
              padding: .22rem 0
              -webkit-box-sizing: border-box
              -moz-box-sizing: border-box
              box-sizing: border-box
              &:last-child
                border: none
              h6
                overflow: hidden
                white-space: nowrap
                text-overflow: ellipsis
                font-size: .3rem
                color: #333
              p
                font-size: .22rem
                color: #999
  #fix-bar
    position: fixed
    bottom: 0
    left: 50%
    z-index: 1002
    display: flex
    justify-content: space-between
    align-items: center
    width: 7.5rem
    height: 1.08rem
    padding: 0 .2rem 0 .4rem
    margin: 0 0 0 -3.75rem
    background-color: #fff
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    .price
      font-size: .5rem
      color: #FF7052
      &::before
        content: "￥"
        display: inline-block
        font-size: .26rem
        color: #FF7052
    .pay
      display: flex
      width: 4.24rem
      height: .8rem
      overflow: hidden
      -webkit-border-radius: 2rem
      -moz-border-radius: 2rem
      border-radius: 2rem
      a
        display: block
        width: 50%
        height: 100%
        line-height: .8rem
        background-color: #FF7052
        color: #fff
        text-align: center
        &:first-child
          background-color: #FFC452
  .clear
    height: 1.08rem
    clear: both
</style>



// WEBPACK FOOTER //
// src/components/class/ClassDetailTeacher.vue